
  <Styles :styles="this.styles"/>
  <component :is="this.Widget" v-bind="this.props"/>
